export const focus = {
    // Quand l'élément lié est inséré dans le DOM...
    inserted(el: any, binding: any): void {
      // L'élément prend le focus
      if (!binding.value) return
      el.focus()
    }
}